import { nToPx, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const exportModalContainerClass = style({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  maxWidth: 650,
});

export const exportModalContentClass = style({
  width: '100%',
  minWidth: 500,
  fontSize: themeVars.font.size.textLg,
});

export const exportModalContentDisclaimerClass = style({
  margin: nToPx(themeVars.space.x6, 0, themeVars.space.x4),
});
